import { ensureJourneyDb, writeAudit } from "../../db";
import { FILE_PACKET_KEY, LIFECYCLE_STAGES } from "./constants";

function emptyLifecycle() {
  return Object.fromEntries(
    LIFECYCLE_STAGES.map((stage) => [stage.id, { status: "not_started", notes: "", updatedAt: "" }])
  );
}

export function emptyOverlay(id) {
  return {
    id,
    status: "active",
    profileNotes: "",
    customSteps: [],
    sellerMilestones: { statuses: {}, notes: "" },
    lifecycle: emptyLifecycle(),
    attachments: [],
    pdfPacket: null,
    updatedAt: "",
  };
}

function readAll() {
  try {
    const raw = JSON.parse(localStorage.getItem(FILE_PACKET_KEY) || "{}");
    return raw && typeof raw === "object" && !Array.isArray(raw) ? raw : {};
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(FILE_PACKET_KEY, JSON.stringify(map));
}

export function getOverlay(id) {
  if (!id) return emptyOverlay("");
  const row = readAll()[id];
  if (!row) return emptyOverlay(id);
  return {
    ...emptyOverlay(id),
    ...row,
    sellerMilestones: {
      statuses: row.sellerMilestones?.statuses || {},
      notes: row.sellerMilestones?.notes || "",
    },
    lifecycle: { ...emptyLifecycle(), ...(row.lifecycle || {}) },
    customSteps: Array.isArray(row.customSteps) ? row.customSteps : [],
    attachments: Array.isArray(row.attachments) ? row.attachments : [],
  };
}

export function saveOverlay(id, patch, session, auditType, metadata = {}) {
  if (!id) return emptyOverlay("");
  const current = getOverlay(id);
  const next = {
    ...current,
    ...patch,
    id,
    sellerMilestones: patch.sellerMilestones
      ? {
          statuses: patch.sellerMilestones.statuses || {},
          notes: patch.sellerMilestones.notes || "",
        }
      : current.sellerMilestones,
    lifecycle: patch.lifecycle ? { ...current.lifecycle, ...patch.lifecycle } : current.lifecycle,
    customSteps: patch.customSteps || current.customSteps,
    attachments: patch.attachments || current.attachments,
    updatedAt: new Date().toISOString(),
  };
  const map = readAll();
  map[id] = next;
  writeAll(map);

  if (auditType && session?.userId) {
    ensureJourneyDb();
    writeAudit({
      user_id: session.userId,
      action_type: auditType,
      transaction_id: id.startsWith("buyer--") || id.startsWith("seller--") ? null : id,
      metadata: { file_id: id, ...metadata },
    });
  }
  return next;
}

export function stampPdfPacket(id, session, filename) {
  return saveOverlay(
    id,
    {
      pdfPacket: {
        generatedAt: new Date().toISOString(),
        filename: filename || "dreamhome-file-packet.pdf",
      },
    },
    session,
    "file.packet_export",
    { filename }
  );
}
